import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  // Méthode pour récupérer un élément du localStorage
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Méthode pour stocker un élément dans le localStorage
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Méthode pour supprimer un élément du localStorage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Méthode pour vider tout le localStorage
  clear(): void {
    localStorage.clear();
  }
}